module.exports = __webpack_public_path__ + "img/1539220016.f273e2cb.jpg";